/*
  OliveDrab — alt text for third-party widget images

  The Zoko WhatsApp button is injected by the app at runtime with an <img>
  that carries no alt attribute, so a screen reader announces the file name
  and Lighthouse fails the page. Every image the theme itself renders already
  has alt; this one is not ours to author.

  So it is labelled from the outside. The rules here are deliberately narrow:

  - only an <img> with NO alt attribute is touched. One the vendor has
    already labelled, even with an empty alt, is left exactly as it is.
  - only inside a container the settings name, never every stray image on
    the page, so a vendor who ships a real label later is not overridden.
  - the observer is cheap and disconnects nothing else.

  This reaches into another app's DOM, which is fragile by nature: if Zoko
  changes its markup this quietly stops matching. It is a stopgap while they
  fix it at source, not a permanent fix.

  Designed by Thriftizer.
*/
(function () {
  'use strict';

  // looked up by id, not document.currentScript — that is null in a
  // deferred script, and this one has to be deferred to stay off the
  // critical path
  var el = document.getElementById('od-vendor-a11y');
  var selector = (el && el.dataset.selector) || '';
  var label = (el && el.dataset.label) || '';
  if (!selector || !label) return;

  var sels = selector.split(',').map(function (s) { return s.trim(); }).filter(Boolean);
  if (!sels.length) return;

  // Start from the image and look upwards, rather than starting from the
  // container and looking down. The widget appends its <img> after its own
  // wrapper is already on the page, so the node the observer hands over is
  // the image itself — a container-first match never sees it.
  function label1(img) {
    // already authored by the vendor — leave it alone, empty alt included
    if (!img || img.hasAttribute('alt')) return;
    for (var i = 0; i < sels.length; i++) {
      try {
        if (img.closest(sels[i])) {
          img.setAttribute('alt', label);
          return;
        }
      } catch (e) { /* a selector the browser will not parse */ }
    }
  }

  function sweep(root) {
    if (!root) return;
    if (root.tagName === 'IMG') label1(root);
    if (root.querySelectorAll) root.querySelectorAll('img').forEach(label1);
  }

  sweep(document);

  // the widget mounts well after the page, so watch for it arriving
  new MutationObserver(function (records) {
    records.forEach(function (r) {
      r.addedNodes.forEach(function (n) {
        if (n.nodeType === 1) sweep(n);
      });
    });
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
